const musicPlayerPrefix = "MUSIC_PLAYER/"

export default {
    setPlayer: musicPlayerPrefix+"SET_PLAYER",
    currentTrack: musicPlayerPrefix+"CURRENT_TRACK",
    playerProgress: musicPlayerPrefix+"PROGRESS",
    isPlaying: musicPlayerPrefix+"ISPLAYING",
    shuffleMode: musicPlayerPrefix+"SHUFFLE",
    context: musicPlayerPrefix+"CONTEXT",
    repeatMode: musicPlayerPrefix+"REPEAT_MODE",
    volume: musicPlayerPrefix+"VOLUME",
    player: musicPlayerPrefix+"VOLUME",
}
